import { useQuery } from '@tanstack/react-query';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { companiesApi } from '@/api';

interface CompanySelectProps {
  value: string;
  onValueChange: (val: string) => void;
  includeAll?: boolean;
  allLabel?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export function useCompanies() {
  return useQuery({
    queryKey: ['companies'],
    queryFn: () => companiesApi.list(),
    staleTime: 1000 * 60 * 10, // 10 min — company list rarely changes
  });
}

export default function CompanySelect({
  value,
  onValueChange,
  includeAll = false,
  allLabel = 'All Companies',
  disabled = false,
  placeholder = 'Select company…',
  className,
}: CompanySelectProps) {
  const { data: companies, isLoading } = useCompanies();

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled || isLoading}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={isLoading ? 'Loading…' : placeholder} />
      </SelectTrigger>
      <SelectContent>
        {includeAll && <SelectItem value="all">{allLabel}</SelectItem>}
        {companies?.map((c) => (
          <SelectItem key={c} value={c}>
            {c}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
